import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { clearSession, hasSession, isTokenExpired, refreshSession } from './auth/session';

// "ok": the access token is good. "refreshing": it has run out but there is a
// refresh token to swap for a new one. "out": nothing to carry on with.
const initialStatus = () => {
  if (!isTokenExpired(localStorage.getItem('accessToken'))) return 'ok';
  return localStorage.getItem('refreshToken') ? 'refreshing' : 'out';
};

const PrivateRoute = ({ children }) => {
  const [status, setStatus] = useState(initialStatus);

  useEffect(() => {
    if (status !== 'refreshing') return undefined;
    let live = true;
    // A failed refresh only ends the session when the API said no; offline,
    // the refresh token is kept and the page carries on until it can retry.
    refreshSession().then(() => {
      if (live) setStatus(hasSession() ? 'ok' : 'out');
    });
    return () => {
      live = false;
    };
  }, [status]);

  if (status === 'refreshing') return null;

  if (status === 'out') {
    clearSession();
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default PrivateRoute;
